import React, { Component } from 'react'
import {
    createStyles,
    TableRow,
    Theme,
    Typography,
    withStyles,
    WithStyles,
    TableCell
} from '@material-ui/core'
import { withTranslation, WithTranslation } from 'react-i18next'
import { ANIMATION } from '../../../material.theme'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import UtilDatePicker from '../../date.and.hour/date'
import { FollowUp, HistologicalTypes, StatusPatient } from '../../../store/application/models/followUp/followUp'

const Style = (theme: Theme) => createStyles({
    ...ANIMATION,

})

interface IProps {
    readonly followUp: FollowUp
    readonly index: number
}

type IJoinProps = WithTranslation & IProps & WithStyles<typeof Style> & RouteComponentProps<any>

export class FollowUpLineComponent extends Component<IJoinProps> {

    public render() {
        const {
            t,
            classes,
            followUp,
            index,
            history
        } = this.props
        const date_created: string = UtilDatePicker.formatDate(followUp.created_at, 'L')
        const date_finished: string =  UtilDatePicker.formatDate(followUp?.finished_at, 'L')|| t(`REGISTER.CURRENT`)
        const values = Object.values(HistologicalTypes).map(valueLower => valueLower.toLowerCase()) as string[]      

        return <TableRow
            hover={true}
            onClick={() => history.push(`/app/home/${followUp.patient_id}/followups/${followUp.id}`)}
            key={`table_row_${index}`}
            className={classes.fadeIn1}
        >

            <TableCell align='center' width={80}>
                {/* Numero de item*/}
                <Typography variant="caption">
                    {index + 1 || ' - - '}
                </Typography>
            </TableCell>
            <TableCell align='center'>
                {/*  Tipo histologico*/}
                <Typography variant="caption">
                    {
                        (followUp.diagnostics?.histological_type || []).map(item =>
                            values[values.indexOf(item)] || `${item}*`).join(', ') || ' - - '}
                </Typography>
            </TableCell>
            <TableCell align='center'>
                {/* Tipo do caso */}
                <Typography variant="caption">
                    {followUp.diagnostics?.case_type !== undefined ? followUp.diagnostics?.case_type : ' - - '}
                </Typography>
            </TableCell>
            <TableCell align='center'>
                {/* Data de acompanhamento */}
                <Typography variant="caption">
                    {(`${date_created} - ${date_finished}`) || ' - - '}
                </Typography>
            </TableCell>
            <TableCell align='center' >
                { /* Situacao */}
                <Typography variant="caption">

                    {

                        followUp.conducts?.stage !== undefined ? (
                            followUp.conducts?.stage === StatusPatient.TRACKING.toLowerCase() ? t("TABLE.OPEN") : t("TABLE.CLOSED")
                        ) : ' - - '
                    }
                </Typography>
            </TableCell>
        </TableRow>
    }
}

const FollowUpLineWithTranslation = withTranslation()(FollowUpLineComponent)

const FollowUpwithStyles: any = withStyles<any>(Style)(FollowUpLineWithTranslation)

const FollowUpLine: any = withRouter(FollowUpwithStyles)

export default FollowUpLine